import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useFormatMessage, useFormatUserName, useFormatDateTime } from 'hooks';

export default ({ onSubmit, logs, id, currentUserId, entityName }) => {
  const { register, handleSubmit, reset } = useForm({
    defaultValues: {
      payload: '',
      type: 'COMMENT',
      entityId: id,
      authorId: currentUserId,
      entityClass: entityName,
    },
  });

  // When logs are updated, reset log form
  useEffect(() => {
    if (logs) {
      reset();
    }
  }, [logs]);

  return (
    <section className="section activity-section">
      <h3 className="title is-3">{useFormatMessage(`ActivitiesLog.title`)}</h3>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="field is-horizontal has-addons">
          <div className="control is-expanded">
            <textarea
              id="payload"
              name="payload"
              className="textarea"
              placeholder={useFormatMessage(`ActivitiesLog.payloadPlaceholder`)}
              rows="1"
              style={{ resize: 'none' }}
              ref={register}
            />
            <input id="type" name="type" type="hidden" ref={register} />

            <input id="entityId" name="entityId" type="hidden" ref={register} />
            <input id="authorId" name="authorId" type="hidden" ref={register} />
            <input
              id="entityClass"
              name="entityClass"
              type="hidden"
              ref={register}
            />
          </div>

          <div className="control is-flex is-flex-direction-column">
            <button type="submit" className="button is-flex-grow-1 px-5">
              {useFormatMessage(`ActivitiesLog.submit`)}
            </button>
          </div>
        </div>
      </form>
      <div className="content activity-section-logs">
        {logs.map((log) => {
          let payloadStr = log.payload;
          const author = useFormatUserName(log.author);
          let title = author;
          const { action } = log;

          if (action === 'CREATE') {
            payloadStr = `Created by ${author}.`;
            title = '';
          } else if (action === 'UPDATE') {
            payloadStr = `Updated by ${author}.`;
            title = '';
          } else if (action === 'ARCHIVE') {
            payloadStr = `Archived by ${author}.`;
            title = '';
          }

          if (typeof payloadStr !== 'string') {
            payloadStr = 'N/A';
          }

          return (
            <div key={log.id || log.createdAt} className="activity-section-log">
              <div className="is-flex activity-section-log-title">
                <h6 title={log.authorId}>{title}</h6>
                <span
                  title={log.authorId}
                  className="has-text-grey-light activity-section-log-datetime"
                >
                  {useFormatDateTime(log.createdAt)}
                </span>
              </div>
              <p className="has-background-white-bis activity-section-log-content">
                {payloadStr}
              </p>
            </div>
          );
        })}
      </div>
    </section>
  );
};
